import { useContext } from 'react';
import { useParams } from 'react-router-dom';
import { GeneralStatus } from 'modules/status-badge';
import { useWorkPeriods } from 'modules/work-weeks';
import { Week } from 'modules/work-weeks/types';
import { WeekDetailsContext } from './components/Context';
import { WeekDetailsContextState } from './types';

export const useWeekDetails = (): WeekDetailsContextState => {
  const context = useContext(WeekDetailsContext);

  if (context === undefined) {
    throw Error(
      'WeekDetailsContext must be used inside WeekDetails Context Provider scope'
    );
  }

  return context;
};

export const useWeekPeriod = (): {
  weekId: string | undefined;
  weekPeriod: Week | undefined;
  isWeekOpen: boolean;
  isLoading: boolean;
} => {
  const { workPeriods, isLoading } = useWorkPeriods();
  const { weekId } = useParams();

  const weekPeriod =
    weekId && workPeriods?.weeks ? workPeriods.weeks[weekId] : undefined;
  const isWeekOpen = weekPeriod?.weekStatus === GeneralStatus.OPEN;

  return {
    weekId,
    weekPeriod,
    isWeekOpen,
    isLoading
  };
};
